import React, { lazy, useEffect } from "react";
import { connect } from "react-redux";
import { setViewTickets } from "../../../actions/socialResponseActions";
const LoadableSMR = lazy(() => import("../SMR/SMR"));

const SMRViewTickets = (props) => {
    useEffect(() => {
        const temporaryId = props.match.params.id;
        let filters = JSON.parse(sessionStorage.getItem(temporaryId));

        filters.extraFilters["statusGroup"] = true;
        filters.sortOption = "post_updated_at";
        filters.syncSortOption = "all";

        props.setViewTickets(filters);
    }, []);

    return <LoadableSMR {...props} isSMRViewTickets={true} />;
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    setViewTickets: (data) => dispatch(setViewTickets(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SMRViewTickets);
